'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';


import { logoutAction } from '@/features/auth';
import { useAuthFavoriteStore } from '@/features/favorites/model/authFavoriteStore';
import { useUserStore } from '@/features/user';
import { SITE_PAGES } from '@/shared/config';
import { getApiErrorMessage } from '@/shared/lib';

export const useLogout = () => {
  const { setUser, logout: clearUserStore } = useUserStore();
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();

  const logout = async () => {
    try {
      await logoutAction();
      setUser(null);
      clearUserStore();
      useAuthFavoriteStore.getState().clear();
      router.replace(SITE_PAGES.main);
    } catch (error) {
      setError(getApiErrorMessage(error));
    }
  };

  return { logout, error };
};
